var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container",style:({ 'background-image': ("url(" + (_vm.$config.get('background')) + ")") })},[_c('div',{attrs:{"id":"youtube-player"}})])}
var staticRenderFns = []

export { render, staticRenderFns }